import { Component, OnInit } from '@angular/core';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { JobModel } from 'src/app/models/job.model';
import { ClientService } from 'src/app/services/client/client.service';
import { AssetService } from 'src/app/services/asset/asset.service';
import { AssetModel } from 'src/app/models/asset.model';
import { ObservationModel } from 'src/app/models/observation.model';

import { Constants } from 'src/app/constants/constants';
import Swiper from 'swiper';

@Component({
  selector: 'app-modal-quote',
  templateUrl: './modal-quote.component.html',
  styleUrls: ['./modal-quote.component.scss'],
})
export class ModalQuoteComponent  implements OnInit {

  selectedAssets = [];
  selectedPhotos = [];
  selectedJob: JobModel = null;
  swiperEl = null;
  swiperSlideIndex = 0;
  notes = "";
  title = "Survey Report";

  constructor(public appearanceService: AppearanceService, public modalController: ModalController,
      public clientService: ClientService, public assetService: AssetService
  ) { }

  ngOnInit() {}

  ionViewWillEnter()
  {    
    this.getBase64forImages()
  }

  ionViewDidEnter()
  {
    this.setUpSwiper();
  }

  ionViewWillLeave() 
  {

  }

  selected(asset, observation, choice)
  {
    var found = false;

    // custom remedials come with quantity =0
    if(choice.quantity == 0)
    {
      choice.quantity = 1;
    }

    for(var i = 0; i < this.selectedAssets.length; i++)
    {
      if(this.selectedAssets[i].uid == asset.uid)
      {
        this.selectedAssets[i].observations.push(observation);
        found = true;
        choice.selected = !choice.selected;
      }

    }
    
    if(!found)
    {
      var newAsset = new AssetModel();
      newAsset.uid = asset.uid;
      newAsset.name = asset.name;
      newAsset.observations = new Array<ObservationModel>();

      observation.selected = true;
      choice.selected = true;

      newAsset.observations.push(observation);

      this.selectedAssets.push(newAsset);
    }
  }

  
  increaseStlQuanity(choice)
  {
    choice.quantity += 1;
  }


  decreaseStlQuanity(choice)
  {
    choice.quantity--;
  
    if(choice.quantity <= 0)
    {
      choice.quantity = 0;
      choice.selected = false;
    }
  }
  

  setUpSwiper()
  {
    this.swiperSlideIndex = 0;

    this.swiperEl = new Swiper(document.querySelector<HTMLElement>('.swiper'),
    {
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 500,
        modifier: 1,
        slideShadows: false,
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });

    var that = this;

    this.swiperEl.on('slideChange', function () {
      that.swiperSlideChanged(this);
    });
  }


  swiperSlideChanged(data)
  {
    this.swiperSlideIndex = data.realIndex;
  }

  selectPhoto(assetIndex, photoIndex)
  {
    this.selectedJob.assets[assetIndex].photos[photoIndex].selected = true;

    var assetPhoto = {
      assetUid: this.selectedJob.assets[assetIndex].uid,
      photoUid: this.selectedJob.assets[assetIndex].photos[photoIndex].uid,
      s3Path: this.selectedJob.assets[assetIndex].photos[photoIndex].s3Path
    };

    this.selectedPhotos.push(assetPhoto);
    console.log(this.selectedPhotos)

  }

  removePhotoSelection(assetIndex, photoIndex, photoUid)
  {
    for (var i = 0; i < this.selectedPhotos.length; i++)
    {
      if (this.selectedPhotos[i].photoUid == photoUid)
      {
        this.selectedJob.assets[assetIndex].photos[photoIndex].selected = false;
        this.selectedPhotos.splice(i, 1);
        break;
      }
    }
  }

  selectObservation(asset, observation)
  {
    var found = false;
    var selected = false;

    for(var i = 0; i < this.selectedAssets.length; i++)
    {
      if(this.selectedAssets[i].uid == asset.uid)
      {
        this.selectedAssets[i].observations.push(observation);
        found = true;
        selected = true;
      }

    }
    
    if(!found)
    {
      var newAsset = new AssetModel();
      newAsset.uid = asset.uid;
      newAsset.name = asset.name;
      newAsset.observations = new Array<ObservationModel>();

      newAsset.observations.push(observation);

      this.selectedAssets.push(newAsset);
      selected = true;
    }

    if(selected)
    {
      observation.selected = true;

      for (var i = 0; i < observation.chosenRemedials.length; i++)
      {
        observation.chosenRemedials[i].selected = true;
      }

      for (var i = 0; i < observation.customRemedials.length; i++)
      {
        observation.customRemedials[i].selected = true;

        if(observation.customRemedials[i].quantity == 0)
        {
          observation.customRemedials[i].quantity = 1;
        }
      }
    }

    console.log(this.selectedAssets)
  }

  removeObservation(assetUid, observation)
  {
    for(var i = 0; i < this.selectedAssets.length; i++)
    {
      if(this.selectedAssets[i].uid == assetUid)
      {
        for (var x = 0; x < this.selectedAssets[i].observations.length; x++)
        {
          if(this.selectedAssets[i].observations[x].uid == observation.uid)
          {
            this.selectedAssets[i].observations.splice(x, 1);
            observation.selected = false;
          }
        }

        if(this.selectedAssets[i].observations.length == 0)
        {
          this.selectedAssets.splice(i, 1);
        }
      }
    }
    console.log(this.selectedAssets)
  }

  generateQuote()
  {
    var returnData = {
      selectedAssets: this.selectedAssets,
      photos: this.selectedPhotos,
      title: this.title,
      notes: this.notes
    };

    this.closeModal(returnData);
  }

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'JobQuoteModal');
  }

  async getBase64forImages()
  {
    var that = this;

    for (var x = 0; x < this.selectedJob.assets.length; x++)
    {
      this.selectedJob.assets[x].photos.forEach(function (item, i, photos) {

        item.loading = true;

        that.assetService.getAssetImage(item.s3Path, that.selectedJob.assets[x].jobAssetUid, that.clientService.getClientUid(), that.clientService.getOrganisationUid()).subscribe(response => {

          if (response.Success)
          {
            if (photos[i])
            {
              photos[i].loading = false;
              photos[i].base64 = response.Image;
            }
          }
          else
          {
            that.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
          }
        },
        err => {
    
          that.appearanceService.dismissLoading();
          that.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        });     
      });   
    }
  }

  getObservationClass(observation)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'condemned-card';
    }
    else if (observation.repairedOnJobUid)
    {
      return 'repaired-card';
    }
    else if (observation.recommendedOnJobUid)
    {
      return 'recommended-card';
    }

    return 'obs-card';
  }


  getObservationCardTitle(observation)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'Condemned';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "Recommended";
    }
    else if (observation.repairedOnJobUid)
    {
      return "Repaired";
    }

    return observation.conditionCode;
  }


  getObservationCardTitleColor(observation)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'danger';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "warning";
    }
    else if (observation.repairedOnJobUid)
    {
      return "success";
    }

    return ""
  }

}
